import { useEffect, useState } from "react";
import { BoxTitle, checkFalsyValues } from "./Overview";
import Basic from "../Basic";
import { Divider } from "@mui/material";
import useApi from "../../../Hooks/useApi";
import LoadingSpinner from "../../Shared/LoadingSpinner";
import { NoDataBox } from "../../UI/Charts/NoDataFoundMessage";


const CityInfosGrid = ({ data, isComparison }) => {
  if (!data || data.length === 0) {
    return (
     <NoDataBox/>
    );
  }
  return (
    <div
      className={`${
        isComparison
          ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full"
          : "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 w-full"
      }`}
    >
      {data.map((dataItem, index) => (
        <Basic key={index} data={{ ...dataItem, text: dataItem?.indicator }} />
      ))}
    </div>
  );
};

const InstitutionalCapacity = ({ isComparison, firstCity, secondCity }) => {
  const { request, loading: loadingFirst } = useApi({ isPublic: true });
  const { request: requestSecond, loading: loadingSecond } = useApi({
    isPublic: true,
  });

  const [firstCityCapacity, setFirstCityCapacity] = useState();
  const [secondCityCapacity, setSecondCityCapacity] = useState();

  const getCapacityData = async (city, year, setter, requester) => {
    try {
      const response = await requester(
        "GET",
        `/v1/city-profile/institutional_capacity?location=${city}&year=${year}`,
        {},
        "survey_service"
      );
      setter(checkFalsyValues(response));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (firstCity?.city && firstCity?.year) {
      getCapacityData(
        firstCity.city.id,
        firstCity.year,
        setFirstCityCapacity,
        request
      );
    } else {
      setFirstCityCapacity();
    }
  }, [firstCity?.city, firstCity?.year]);

  useEffect(() => {
    if (isComparison && secondCity?.city && secondCity?.year) {
      getCapacityData(
        secondCity.city.id,
        secondCity.year,
        setSecondCityCapacity,
        requestSecond
      );
    } else {
      setSecondCityCapacity();
    }
  }, [secondCity?.city, secondCity?.year]);

  const isLoading = loadingFirst || (isComparison && loadingSecond);

  return (
    <div
      id="InstituitionalCapacity"
      className="border border-[#2F4B7C] border-opacity-30 p-5"
    >
      <BoxTitle title="Instituitional Capacity" />

      {isLoading ? (
        <LoadingSpinner message="Loading Institutional Capacity..." />
      ) : (
        <div
          className={`${
            isComparison ? "space-y-5" : "flex flex-col xl:flex-row gap-2"
          }`}
        >
          <h1 className="text-[#2F4B7C] text-center xl:text-start text-lg  2xl:text-[19.25px] font-semibold xl:w-1/4 mb-3 xl:mb-0">
            Human Resources
          </h1>

          <div className="flex gap-5 w-full">
            <div className="flex-1 w-full">
              <CityInfosGrid
                data={firstCityCapacity?.["Human Resources"]}
                isComparison={isComparison}
              />
            </div>

            {isComparison && (
              <>
                <Divider orientation="vertical" flexItem className="h-full" />
                <div className="flex-1 w-full">
                  <CityInfosGrid
                    data={secondCityCapacity?.["Human Resources"]}
                    isComparison={isComparison}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default InstitutionalCapacity;
